import { useEffect, useRef, useState } from 'react';

const SEL = 'main .overflow-x-auto:has(> table), main .overflow-auto:has(> table)';

// Barra de scroll horizontal flutuante para tabelas cujo fundo está fora do ecrã
export const FloatingHScroll = () => {
  const barRef = useRef(null);
  const targetRef = useRef(null);
  const [box, setBox] = useState(null);

  useEffect(() => {
    const update = (ev) => {
      if (ev && ev.target === barRef.current) return;
      const vh = window.innerHeight;
      const el = [...document.querySelectorAll(SEL)].find((e) => {
        const r = e.getBoundingClientRect();
        return e.scrollWidth > e.clientWidth + 2 && r.top < vh - 60 && r.bottom > vh;
      });
      const changed = targetRef.current !== el;
      targetRef.current = el || null;
      if (!el) { setBox(null); return; }
      const r = el.getBoundingClientRect();
      setBox((b) => (b && b.left === r.left && b.width === el.clientWidth && b.inner === el.scrollWidth ? b : { left: r.left, width: el.clientWidth, inner: el.scrollWidth }));
      if (changed) requestAnimationFrame(() => { if (barRef.current) barRef.current.scrollLeft = el.scrollLeft; });
    };
    const onTableScroll = (e) => {
      if (e.target === targetRef.current && barRef.current) barRef.current.scrollLeft = e.target.scrollLeft;
    };
    update();
    const iv = setInterval(update, 1000);
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);
    document.addEventListener('scroll', onTableScroll, true);
    return () => {
      clearInterval(iv);
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
      document.removeEventListener('scroll', onTableScroll, true);
    };
  }, []);

  if (!box) return null;
  return (
    <div
      ref={barRef}
      data-testid="floating-hscroll"
      onScroll={(e) => { if (targetRef.current) targetRef.current.scrollLeft = e.currentTarget.scrollLeft; }}
      className="fixed bottom-0 z-40 overflow-x-auto overflow-y-hidden bg-white/90 backdrop-blur border-t border-slate-200 shadow-[0_-2px_8px_rgba(0,0,0,0.06)]"
      style={{ left: box.left, width: box.width, height: 16, scrollbarColor: '#94a3b8 #f1f5f9' }}
    >
      <div style={{ width: box.inner, height: 1 }} />
    </div>
  );
};
